// material
import { Stack } from "@mui/material";

// ----------------------------------------------------------------------

export default function WhatItIs() {
  return (
    <>
      <Stack direction="row" sx={{ borderBottom: "1px solid #ffffff80" }}>
        <Stack
          sx={{
            width: { xs: "100%", md: "83%" },
            position: "relative",
            px: "2%",
          }}
        >
          <p className="what_it_is">WHAT IT IS</p>
          <img
            alt="Star3"
            src="/assets/Star3.svg"
            style={{
              width: "60px",
              height: "56px",
              position: "absolute",
              right: "-30px",
              bottom: "-28px",
            }}
          />
        </Stack>
        <Stack sx={{ margin: "auto", width: { xs: "0", md: "17%" } }}></Stack>
      </Stack>
      <Stack direction="row" sx={{ borderBottom: "1px solid #ffffff80" }}>
        <Stack
          spacing={5}
          sx={{
            width: { xs: "100%", md: "50%" },
          }}
        >
          <img
            src="/assets/KHADIJA-2.png"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </Stack>
        <Stack sx={{ width: { xs: "0", md: "50%" } }}>
          <Stack sx={{ borderBottom: "1px solid #ffffff80" }}>
            <p className="whatitis_title">
              A MISSION TO SHINE A LIGHT ON LOCAL TALENT, CREATORS AND
              COMMUNITIES
            </p>
          </Stack>
          <Stack spacing={3} sx={{ p: "7%" }}>
            <p className="whatitis_content">
              R/HOOD is the world's first on-chain creative neighbourhood,
              creating an off-chain community. R/HOOD is a creative curator and
              facilitator, supported by an NFT membership housed on the web3
              open source infrastructure.
            </p>
            <p className="whatitis_content">
              After completing our 2023 roadmap, R/HOOD will be able to source
              music, art, and creative expression from local communities across
              the world. This will bring together unique and fruitful
              connections between people from across the world. It will form a
              new digital neighbourhood with local talent, on a global scale.
            </p>
            <p className="whatitis_content">
              Our mission is to shine a light on local talent, creators, and
              communities from various neighbourhoods across the globe, and
              introduce them to a global audience.
            </p>
            <p className="whatitis_content">
              We bridge the gap between IRL experiences and online communities.
            </p>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
}
